// Marketing campaign-review buckets — the single source of truth shared by the
// review list/kanban (LeadsPage) and the review detail decision bar
// (CompanyDetailPage), so the active bucket always matches between the two views.
//
// Each bucket maps to one or more raw review_status labels. `marketingBucketOf`
// resolves a status label to its bucket id; anything unrecognised (including
// Pending/Opened) falls into "to-review".

export const MKT_BUCKETS = [
  { id: "to-review",  title: "To Review",       sub: "Not reviewed yet",         c: "#5F1156", statuses: ["Pending", "Opened"] },
  { id: "campaign",   title: "MQL",             sub: "Pushed to AC or Mindbox",  c: "#16a34a", statuses: ["Pushed to Active Campaign", "Pushed to Mindbox"] },
  { id: "rejected",   title: "Rejected",        sub: "Not for this campaign",    c: "#C1121F", statuses: ["Rejected", "Excluded"] },
  { id: "enrichment", title: "Needs Enrichment", sub: "Missing contact info",    c: "#9a5b00", statuses: ["Needs Enrichment"] },
];

// Review status label → bucket id. Keep this the only place that encodes the mapping.
export function marketingBucketOf(status) {
  const bucket = MKT_BUCKETS.find((b) => b.statuses.includes(status));
  return bucket ? bucket.id : "to-review";
}

// Whether a lead has usable contact info. Prefers the authoritative server flag
// (`has_contact`, computed from company_contacts + firmographics — the same
// source the company detail uses); falls back to the raw email/phone fields when
// the flag isn't present. Shared so the review table's "Contact" column and any
// contact-aware UI use one definition.
export function hasContactInfo(c) {
  if (c?.has_contact !== undefined && c?.has_contact !== null) return Boolean(c.has_contact);
  return Boolean((c?.email && String(c.email).trim()) || (c?.phone && String(c.phone).trim()));
}
